import {
  CollectionItem,
  LoaderUnsure,
  UiconCircleTick,
  UiconKeyHorizontal
} from '@stratumn/atomic';
import { sig } from '@stratumn/js-crypto';
import PropType from 'prop-types';
import React from 'react';

export class GenerateKey extends React.Component {
  static propTypes = {
    onSigningKeyGeneration: PropType.func.isRequired,
    signingKey: PropType.object
  };

  static defaultProps = {
    signingKey: null
  };

  // Used to cancel key generation function on unmounting.
  immediateKeyGeneration;

  componentDidMount() {
    this.immediateKeyGeneration = setTimeout(() => {
      this.generateSigningKey();
    }, 0);
  }

  componentWillUnmount() {
    if (this.immediateKeyGeneration) {
      clearTimeout(this.immediateKeyGeneration);
    }
  }

  generateSigningKey = () => {
    const { onSigningKeyGeneration } = this.props;

    const signingKey = new sig.SigningKeyPair({ algo: 'ED25519' });
    onSigningKeyGeneration(signingKey);
  };

  render() {
    const { signingKey } = this.props;

    const action = signingKey ? (
      <UiconCircleTick size={27} />
    ) : (
      <LoaderUnsure />
    );

    return (
      <>
        <CollectionItem
          action={action}
          borderless
          idle
          label=""
          prefix={<UiconKeyHorizontal size={20} />}
          value={
            signingKey
              ? 'Signing Key successfully created'
              : 'Generating Signing Key...'
          }
        />
      </>
    );
  }
}

export default GenerateKey;
